<template>
  <div class="header">
        <nav class="content">
            <div class="pcheaderBackground" style="display:none">
                <div class="headerContent">
                    <img @click="goHome" src="../assets/headerLogo.svg"/>
                    <Icon @click="model =true" type="md-menu" size="35" class="menu"/>
                    <ul class="menuUl">
                        <li class="menuLi" @click="goHome">{{langData.header.title1}}</li>
                        <li class="menuLi" @click="goProducts">{{langData.header.title2}}</li>
                        <li class="menuLi" @click="goMexico">
                            {{langData.header.title3}}
                        </li>
                        <li class="menuLi" @click="goAboutUs">{{langData.header.title4}}</li>
                        <li class="menuLi" @click="goContactUs">{{langData.header.title5}}</li>
                        <li class="menuLi">
                            <el-select v-model="language" placeholder="" style="width: 116px;"  @change="changeLanguage">
                                <el-option v-for="item in langData.header.languageOption" :key="item.value" :label="item.label" :value="item.value">
                                    {{ item.label }}
                                </el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="header">
                <img @click="goHome" src="../assets/headerLogo.svg"/>
                <Icon @click="model =true" type="md-menu" size="35" class="menu"/>
                <ul class="menuUl">
                    <li class="menuLi" @click="goHome">{{langData.header.title1}}</li>
                    <li class="menuLi" @click="goProducts">{{langData.header.title2}}</li>
                    <li class="menuLi" @click="goMexico">
                        {{langData.header.title3}}
                    </li>
                    <li class="menuLi" @click="goAboutUs">{{langData.header.title4}}</li>
                    <li class="menuLi" @click="goContactUs">{{langData.header.title5}}</li>
                    <li class="menuLi">
                        <el-select v-model="language" placeholder="" style="width: 116px;"  @change="changeLanguage">
                            <el-option v-for="item in langData.header.languageOption" :key="item.value" :label="item.label" :value="item.value">
                                {{ item.label }}
                            </el-option>
                        </el-select>
                    </li>
                </ul>
            </div>
        </nav>
        <Drawer width='70' v-model="model" :closable="false">
            <div slot="header">
                <img @click="goHome" class="menuHeaderLogo" src="../assets/headerLogo.png"/>
            </div>
            <div style="margin-top:0px;">
                <div @click="goHome" style="padding-bottom: 18px;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">{{langData.header.title1}}</div>
                <div @click="goProductsMobile" style="padding: 18px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">{{langData.header.title2}}</div>
                <div @click="goMexico" style="padding: 10px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">
                    {{langData.header.title3}}
                </div>
                <div @click="goAboutUsMobile" style="padding: 18px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">{{langData.header.title4}}</div>
                <div @click="goContactUs" style="padding: 18px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">{{langData.header.title5}}</div>
                <div style="padding: 18px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">
                    <el-select v-model="language" placeholder="" style="width: 120px;"  @change="changeLanguage">
                        <el-option v-for="item in langData.header.languageOption" :key="item.value" :label="item.label" :value="item.value">
                            {{ item.label }}
                        </el-option>
                    </el-select>
                </div>
            </div>
            
        </Drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../store/index";
import localStorage from "../services/localStorage.service";
const getAndSet = function(name) {
    return {
        // getter
        get: function() {
            return this.$store.state.module[name]
        },
        // setter
        set: function(newValue) {
            this.$store.state.module[name] = newValue
        }
    }
}
export default {
  name: '',
  data () {
    return {
        model:false,
        langData: {
            home:{
                languageOption:[]
            },
        },
    }
  },
  methods:{
        changeLanguageBtn(){
            if(this.language == 'cn'){
                this.language = 'en'
            }else{
                this.language = 'cn'
            }
            this.changeLanguage();
        },
      goContactUs(){
          this.$router.push('/contact')
          window.scrollTo(0, 0)
      },
      goHome(){
          this.model = false
          window.scrollTo(0, 0)
          this.$router.push('/')
      },
      goProducts(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 700)
            }, 100)
          this.$router.push('/')
      },
      goProductsMobile(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 300)
            }, 100)
          this.$router.push('/')
      },
      goMexico(){
          this.$router.push('/mexico')
          window.scrollTo(0, 0)
      },
      goAboutUs(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 3850)
            }, 100)
          this.$router.push('/')
      },
      goAboutUsMobile(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 4350)
            }, 100)
          this.$router.push('/')
      },
      goCountry(name){
          this.$router.push('/'+name)
          window.scrollTo(0, 0)
      },
        changeLanguage() {
        this.$i18n.locale = this.language;

        this.langData = this.$i18n.messages[this.$i18n.locale].message.home;
        }
  },
  created() {
    this.changeLanguage();
    $(window).scroll(function() {
      let topp = $(document).scrollTop();
      if (topp < 40) {
        // 恢复正常流并且瞬间隐藏
        $(".pcheaderBackground").css({
          opacity: 0,
          "pointer-events": "none"
        });
      } else {
        // 先让盒子固定定位在顶部然后下拉
        $(".pcheaderBackground")
          .css({
            opacity: 1,
            position: "fixed",
            top: 0,
            left: 0,
            zIndex:1000,
            "pointer-events": ""
          })
          .slideDown();
      }
    });
  },
    computed: {
		language: getAndSet('language'),
    },
    watch: {
        language: function() {
        this.changeLanguage();
        }
    },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media all and (min-width:960px){
    .header{
        position: relative;
        width: 100%;
        .content{
            color: #FFFFFF;
            // background: rgb(0, 38, 67);
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
            .header{
                width: 80%;
                margin: 0 auto;
                position: relative;
                display: flex;
                padding-bottom: 20px;
                img{
                    width: 210px;
                    height: 42px;
                    margin-top: 18.5px;
                }
                .menu{display: none;}
                .menuUl{
                    position: absolute;
                    right: 0;
                    margin-top: 28.5px;
                    list-style: none;
                    .menuLi{
                        color: #FFFFFF;
                        cursor: pointer;
                        display: inline-block;
                        margin-left: 80px;
                        font-size: 16px;
                        font-family: OpenSans-SemiBold, OpenSans;
                        font-weight: 600;
                    }
                    .menuLi:hover{
                        color: #2d8cf0;
                    }
                    a{
                        color: white;
                    }
                    a:hover{
                        color: #2d8cf0;
                    }
                }
            }
            .pcheaderBackground{
                width: 100%;
                background: rgb(0, 38, 67);
                .headerContent{
                    width: 80%;
                    margin: 0 auto;
                    padding-bottom: 20px;
                    position: relative;
                    display: flex;
                }
                img{
                    width: 210px;
                    height: 42px;
                    margin-top: 18.5px;
                }
                .menu{display: none;}
                .menuUl{
                    position: absolute;
                    right: 0;
                    margin-top: 28.5px;
                    list-style: none;
                    .menuLi{
                        color: #FFFFFF;
                        cursor: pointer;
                        display: inline-block;
                        margin-left: 80px;
                        font-size: 16px;
                        font-family: OpenSans-SemiBold, OpenSans;
                        font-weight: 600;
                    }
                    .menuLi:hover{
                        color: #2d8cf0;
                    }
                    a{
                        color: white;
                    }
                    a:hover{
                        color: #2d8cf0;
                    }
                }
            }
        }
    }
}
@media all and (max-width:960px){
    .header{
        position: relative;
        width: 100%;
        .content{
            color: #FFFFFF;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
            .header{
                margin: 0 18px;
                position: relative;
                display: flex;
                padding-bottom: 20px;
                img{
                    width: 136px;
                    height: 28px;
                    margin-top: 20px;
                }
                .menu{
                    position: absolute;
                    right: 35px;
                    margin-top: 15px;
                }
                .menuUl{
                    display: none;
                }
            }
            .pcheaderBackground{
                width: 100%;
                background: rgb(0, 38, 67);
                .headerContent{
                    margin: 0 18px;
                    position: relative;
                    display: flex;
                    padding-bottom: 20px;
                }
                img{
                    width: 136px;
                    height: 28px;
                    margin-top: 20px;
                }
                .menu{
                    position: absolute;
                    right: -1px;
                    margin-top: 15px;
                }
                .menuUl{
                    display: none;
                }
            }
        }
    }
}
.mobilCountryList{
    ul{
        list-style: none;
        li{
            p{
                display: inline-block;
                width: 31%;
                text-align: left;
                font-size: 11px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color: #fff;
                line-height: 19px;
            }
        }
    }
}
</style>
<style lang="less">
	.el-select .el-input .el-select__caret{
		color: #fff !important;
	}
	.el-select .el-input .el-select__caret:hover{
		color: #2d8cf0 !important;
	}
	.el-select .el-input__inner{
		background-color: transparent !important;
		color:#fff !important;
		border-radius: 8px !important;
		font-size: 16px !important;
		font-weight: 600 !important;
		padding-left: 16px !important;
	}
	.el-select .el-input__inner:hover{
		background-color: transparent !important;
		color:#2d8cf0 !important;
		border-radius: 8px !important;
		// border: none !important;
		font-size: 16px !important;
		font-weight: 600 !important;
	}
	.ivu-select-item {
		font-size: 14px !important;

	}
    .menuHeaderLogo{
        width: 136px;
        height: 28px;

    }
    .ivu-drawer-content{
        background-color: rgb(0,38,67) !important;
    }
    .ivu-drawer-close .ivu-icon-ios-close{
        color:white !important;
    }
    .ivu-drawer-header{
        border-bottom:none !important;
        padding: 20px !important;
    }
    .ivu-drawer-body{
        padding: 20px !important;
        color:#F9FAFE !important;
        font-size: 16px  !important;

    }
    .ivu-drawer-close{
        right:20px !important;
        top:20px !important;
    }
    .ivu-dropdown-menu{
        color: #001B37 !important;
    }
    .ivu-select-dropdown{
        padding: 15px 12px !important;
    }
    .ivu-dropdown-item{
        color: #001B37 !important;
        width: 120px !important;
    }
    .ivu-dropdown-item:hover{
        color: #2d8cf0 !important;
    }
    .ivu-dropdown .ivu-select-dropdown{
        top:55px !important;
    }
    .ivu-collapse-simple{
        background: rgb(0, 38, 67) !important;
    }
    .ivu-collapse-content{
        background: rgb(0, 38, 67) !important;
        color: #fff !important;
        padding:0 !important;
        padding-left:10px !important;
    }
    .ivu-collapse{
        border: 1px solid rgb(0, 38, 67) !important;
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header{
        color: #fff !important;
        padding-left: 0px !important;
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header>i{
        float: right !important;
        margin-top: 10px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/header.vue